// Nuevo módulo Angular para instanciar los NUEVOS componentes que tiene el módulo de Empleados.
// Se importa en app.module.ts

import { NgModule } from "@angular/core";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AdvisorService } from "./advisor.service";
import { AdvisorFormComponent } from "./advisor-form.component";
import { AdvisorListComponent } from "./advisor-list.component";
import { AdvisorDialogInfoDialog } from "./advisor-dialog-info.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
    declarations: [
        AdvisorDialogInfoDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTableModule,
        MatSelectModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatCardModule,
        MatSlideToggleModule,
        BrowserAnimationsModule,
        MatChipsModule
    ],
    providers: [
        AdvisorService
    ]
})
export class AdvisorModule { }
